// Static autocomplete source for the listings search box. Names come ONLY from
// verified sources: the site's six beach-town guides and the communities named
// in the agents' verified active/sold history (PARITY_V2 Parts B/D) — never
// invented.

export interface SearchSuggestion {
  label: string
  kind: 'town' | 'community'
  sublabel?: string // town for a community
}

const TOWNS: SearchSuggestion[] = [
  { label: 'Lewes', kind: 'town' },
  { label: 'Rehoboth Beach', kind: 'town' },
  { label: 'Dewey Beach', kind: 'town' },
  { label: 'Bethany Beach', kind: 'town' },
  { label: 'Fenwick Island', kind: 'town' },
  { label: 'Milton', kind: 'town' },
  { label: 'Georgetown', kind: 'town' },
  { label: 'Millsboro', kind: 'town' },
  { label: 'Milford', kind: 'town' },
  { label: 'Harbeson', kind: 'town' },
  { label: 'Frankford', kind: 'town' },
]

// Communities named in the team's verified listings/solds (PARITY_V2 D.2–D.5).
const COMMUNITIES: SearchSuggestion[] = [
  { label: 'Cannery Village', kind: 'community', sublabel: 'Milton' },
  { label: 'Summerlyn', kind: 'community', sublabel: 'Lewes' },
  { label: 'Deere Pines', kind: 'community', sublabel: 'Georgetown' },
  { label: 'Village Of Cinderberry', kind: 'community', sublabel: 'Georgetown' },
  { label: 'Pinewater Farm', kind: 'community', sublabel: 'Harbeson' },
  { label: 'Wellesley At Hidden Meadows', kind: 'community', sublabel: 'Rehoboth Beach' },
  { label: 'Mill Landing', kind: 'community', sublabel: 'Millsboro' },
  { label: 'Hearthstone Manor', kind: 'community', sublabel: 'Milford' },
  { label: 'Sandpiper Village', kind: 'community', sublabel: 'Rehoboth Beach' },
  { label: 'Pelican Point', kind: 'community', sublabel: 'Millsboro' },
  { label: 'Broadkill Beach', kind: 'community', sublabel: 'Milton' },
  { label: 'Canal Corkran', kind: 'community', sublabel: 'Rehoboth Beach' },
  { label: 'Welches Pond', kind: 'community', sublabel: 'Lewes' },
  { label: 'Indian Beach', kind: 'community', sublabel: 'Rehoboth Beach' },
  { label: 'North Shores', kind: 'community', sublabel: 'Rehoboth Beach' },
  { label: 'Country Club Estates', kind: 'community', sublabel: 'Rehoboth Beach' },
  { label: 'South Rehoboth', kind: 'community', sublabel: 'Rehoboth Beach' },
  { label: 'Lewes Beach', kind: 'community', sublabel: 'Lewes' },
  { label: 'Showfield', kind: 'community', sublabel: 'Lewes' },
  { label: 'Hawkseye', kind: 'community', sublabel: 'Lewes' },
]

export const SEARCH_SUGGESTIONS: SearchSuggestion[] = [
  ...TOWNS,
  ...COMMUNITIES,
].sort((a, b) => a.label.localeCompare(b.label))

// Case-insensitive prefix/substring match, prefix hits ranked first.
export function matchSuggestions(query: string, limit = 8): SearchSuggestion[] {
  const q = query.trim().toLowerCase()
  if (q.length < 2) return []
  const prefix: SearchSuggestion[] = []
  const substr: SearchSuggestion[] = []
  for (const s of SEARCH_SUGGESTIONS) {
    const l = s.label.toLowerCase()
    if (l.startsWith(q)) prefix.push(s)
    else if (l.includes(q)) substr.push(s)
    if (prefix.length >= limit) break
  }
  return [...prefix, ...substr].slice(0, limit)
}
